export function isInactive(peerConnection: RTCPeerConnection) {
    const peerConnectionInactiveStates = new Set([
        "disconnected",
        "failed",
        "closed",
    ]);
    return peerConnectionInactiveStates.has(peerConnection.iceConnectionState);
}
